import React from 'react'
import { IonContent, IonPage } from '@ionic/react'
import HeaderNav from '../../../components/headerNav/HeaderNav.component'
import PCRHeader from '../../../components/pcrHeader/PCRHeader.component'
import { useHistory } from 'react-router'
import { TabConstants } from '../../../components/tabs/Tabs.constants'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import RelationshipsAndGuarantorsContent from '../pageContent/RelationshipsAndGuarantors.content'
import {
  addRelationshipsAndGuarantors,
  clearRelationshipsAndGuarantorsData,
} from '../store/relationshipsAndGuarantors.action'
import ValidationService from '../../validation/services/validation.services'
import { RelationshipsAndGuarantorsConstants } from '../store/relationshipsAndGuarantors.constants'
import { IRelationshipsAndGuarantorsState } from '../store/relationshipsAndGuarantors.types'
import { getRelationshipsAndGuarantors } from '../selectors/getRelationshipsAndGuarantors.selector'
import { hasUnsavedRandGData, showUnsavedDataWarningMessage } from '../../../utilities/unSavedData.util'

const RelationshipsAndGuarantors: React.FC = () => {
  const history = useHistory()
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { relationshipsAndGuarantorsData, relationshipsAndGuarantorsList }: IRelationshipsAndGuarantorsState =
    useSelector(getRelationshipsAndGuarantors)

  const onBackClickYes = () => {
    history.push(TabConstants.BILLING)
    if (hasUnsavedRandGData(relationshipsAndGuarantorsData, relationshipsAndGuarantorsList)) {
      dispatch(clearRelationshipsAndGuarantorsData())
    }
  }

  const onBackClick = () => {
    if (hasUnsavedRandGData(relationshipsAndGuarantorsData, relationshipsAndGuarantorsList)) {
      showUnsavedDataWarningMessage(
        dispatch,
        t,
        t('relationshipsAndGuarantors.unsavedDataWarningMessage'),
        onBackClickYes
      )
      return
    }
    onBackClickYes()
  }

  const onSaveClick = () => {
    dispatch(addRelationshipsAndGuarantors())
    ValidationService.clearValidation(RelationshipsAndGuarantorsConstants.SET_DOB)
    ValidationService.clearValidation(RelationshipsAndGuarantorsConstants.SET_AGE)
    ValidationService.clearValidation(RelationshipsAndGuarantorsConstants.SET_SSN)
  }

  return (
    <IonPage id='RelationshipsAndGuarantorsPage'>
      <PCRHeader />
      <HeaderNav
        prevOnClick={onBackClick}
        prevLabel={t('common.buttons.Back')}
        isBackButton={true}
        nextLabel={t('common.buttons.Save')}
        nextOnClick={onSaveClick}
        title={t('relationshipsAndGuarantors.Relationships')}
      />
      <IonContent color='light'>
        <RelationshipsAndGuarantorsContent isPHI />
      </IonContent>
    </IonPage>
  )
}

export default RelationshipsAndGuarantors
